import React, { useState } from "react";
import { ChevronLeft, ChevronRight, Quote } from "lucide-react";

const quotes = [
    {
        body: "Booked them for a one-off cleanup and ended up on the fortnightly mow. Lawn’s never looked this neat — and they always sweep the path before they leave.",
        author: "Sarah & Tom",
        role: "Homeowner · Suburban backyard",
    },
    {
        body: "The driveway looked like it hadn’t been cleaned in a decade. One afternoon and it’s back to pale concrete. Fair price, no upsell, on time.",
        author: "Michael R.",
        role: "Homeowner · Double driveway",
    },
    {
        body: "Friendly, professional, and properly local. They texted before arriving, finished early, and left a follow-up photo. Already booked them for autumn.",
        author: "Priya K.",
        role: "Property manager · Two duplexes",
    },
];

export default function Testimonials() {
    const [i, setI] = useState(0);
    const q = quotes[i];
    const len = quotes.length;

    return (
        <section
            data-testid="section-testimonials"
            className="relative bg-[var(--paper)] py-28 md:py-36 border-t border-line"
        >
            <div className="maxw section-pad">
                <div className="grid md:grid-cols-12 gap-10 items-end mb-12">
                    <div className="md:col-span-7">
                        <div className="eyebrow mb-5">From the neighbourhood</div>
                        <h3 className="font-display text-3xl md:text-4xl tracking-tight font-light">
                            Honest words from people we actually mow for.
                        </h3>
                    </div>
                    <div className="md:col-span-5 md:text-right">
                        <div className="font-mono-x text-[12.5px] text-[rgba(14,14,16,0.58)]">
                            {String(i + 1).padStart(2, "0")}/
                            {String(len).padStart(2, "0")}
                        </div>
                    </div>
                </div>

                <article
                    className="reveal border border-line rounded-2xl p-8 md:p-14 bg-[var(--paper-2)]/40 relative"
                    data-testid="testimonial-card"
                >
                    <Quote
                        size={48}
                        className="text-[rgba(63,90,36,0.32)] absolute top-6 left-6"
                    />
                    <p
                        data-testid="testimonial-quote"
                        className="font-display text-2xl md:text-3xl lg:text-[34px] leading-[1.3] tracking-tight text-[var(--ink)] max-w-4xl"
                    >
                        “{q.body}”
                    </p>
                    <div className="mt-10 flex flex-wrap items-end justify-between gap-6">
                        <div>
                            <div className="font-display text-xl">{q.author}</div>
                            <div className="font-mono-x text-[12px] text-[rgba(14,14,16,0.58)] mt-1">
                                {q.role}
                            </div>
                        </div>
                        <div className="flex items-center gap-3">
                            <button
                                onClick={() => setI((i - 1 + len) % len)}
                                aria-label="Previous"
                                className="w-11 h-11 rounded-full border border-line-strong flex items-center justify-center hover:bg-[var(--ink)] hover:text-[var(--paper)] transition"
                                data-testid="testimonial-prev"
                            >
                                <ChevronLeft size={18} />
                            </button>
                            <button
                                onClick={() => setI((i + 1) % len)}
                                aria-label="Next"
                                className="w-11 h-11 rounded-full border border-line-strong flex items-center justify-center hover:bg-[var(--ink)] hover:text-[var(--paper)] transition"
                                data-testid="testimonial-next"
                            >
                                <ChevronRight size={18} />
                            </button>
                        </div>
                    </div>
                </article>
            </div>
        </section>
    );
}
